import type { CoreOptions } from "@adyen/adyen-web/dist/types/core/types";

import getApp from "helpers/get_app";
import getEnv from "helpers/get_env";

export const ENV = getEnv();
export const APP = getApp();

export const ADYEN_CONSTANTS: {
  env: CoreOptions["environment"];
  dataCollectionUrl: string;
} = (() => {
  if (ENV === "production") {
    return {
      env: "live-us",
      dataCollectionUrl:
        "https://checkoutshopper-live.adyen.com/checkoutshopper/assets/js/datacollection/datacollection.js",
    };
  }
  return {
    env: "test",
    dataCollectionUrl:
      "https://checkoutshopper-test.adyen.com/checkoutshopper/assets/js/datacollection/datacollection.js",
  };
})();
